export namespace Effects {
  /**
   * Class names to use for the different parts of the annotation
   * icons. This gives us the ability to display only the icon's text
   * component itself (i.e. ?? ) rather than the colored background
   * circle and shadows (so you can hide those paths based on class).
   */
  export enum ClassNames {
    Background = 'icon-background',
    Component = 'icon-component',
    ComponentShadow = 'icon-component-shadow',
    Shadow = 'icon-shadow',
  }
}
